import { UUIDv4 } from '../../../../types';
import { CustomAttributesStatus, Pagination } from '../../../types';

export type InternalCreateCustomAttributeRequest = Omit<
  InternalCustomAttribute,
  'id' | 'possibleValues'
> & {
  possibleValues?: Array<Pick<InternalCustomAttributeValue, 'name'>>;
};

export type InternalUpdateAttributeRequestDefinition = Partial<
  Omit<InternalCustomAttribute, 'id' | 'possibleValues' | 'type' | 'multipleChoice'>
> & {
  possibleValues?: {
    newAttributes?: Array<InternalCustomAttributeValue['name']>;
    updatedAttributes?: Array<InternalCustomAttributeValue>;
    deletedAttributes?: Array<InternalCustomAttributeValue['id']>;
  };
};

export interface InternalCustomAttribute {
  // The ID of the attribute.
  id: UUIDv4;
  // The friendly name of the attribute
  name: string;
  // The type of the attribute
  type: InternalCustomAttributeType;
  description?: string;
  status: InternalCustomAttributeStatus;
  // In case possible values are set, this determines whether the user may select more then 1 value
  multipleChoice?: boolean;
  possibleValues?: Array<InternalCustomAttributeValue>;
}

export enum InternalCustomAttributeType {
  Text = 'text',
  Numeric = 'numeric',
}
export type InternalCustomAttributeStatus = CustomAttributesStatus;

export interface InternalCustomAttributeValue {
  // The ID of the attribute value.
  id: string;
  name: string | number;
}

export interface InternalGetCustomAttributesResponse {
  results: InternalCustomAttribute[];
  pagination: Pagination;
}
